// @flow
import React, {Component} from 'react';
import './CandidateSelect.css';
import type {CandidateSelect as Candidate} from './types';

export default class CandidateSelect extends Component {

  props: {
    candidateSelected: Candidate,
    setCandidate: (c: Candidate) => void,
  }

  change(event: Event) {
    if (!(event.target instanceof HTMLSelectElement)) return;
    // $FlowIgnore
    this.props.setCandidate(event.target.value);
  }

  render() {
    return (
      <div className="candidateSelect">
        <label htmlFor="candidateSelect">Select a candidate </label>
        <select id="candidateSelect" onChange={this.change.bind(this)} value={this.props.candidateSelected}>
          <option value="both">Both</option>
          <option value="hillary">Hillary</option>
          <option value="trump">Trump</option>
        </select>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/CandidateSelect.js
 **/